// extracted by mini-css-extract-plugin
export default {"wrapper":"EditProjectsForm_wrapper__YVjaF","submitWrapper":"EditProjectsForm_submitWrapper__Ld8S4"};